import(/* webpackMode: "eager", webpackExports: ["AddToCartButtonWrapper","TabsWrapper"] */ "/vercel/path0/app/[locale]/products/[slug]/components/ClientComponentWrappers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/products/[slug]/components/ImageSwapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/products/[slug]/components/StyleProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/DynamicPrice.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/products/ProductImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/vercel/path0/components/products/ReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoingFastIndicator"] */ "/vercel/path0/components/ui/goingFast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LimitedStockIndicator"] */ "/vercel/path0/components/ui/limitedStock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
